﻿import { startsWith } from '../utils';

const BLOCK_SELECTOR = '.video';
const BLOCK_BTN_SELECTOR = '.video__action';
const DATA_ID = 'video-id';
const YT_EMBED_URL = 'https://www.youtube.com/embed/';
const YT_ID_LEN = 11;

function swapVideo(e: JQuery.ClickEvent): void {
    e.preventDefault();

    // get current id from src
    // if url not starts with YT_EMBED_URL, set to first video
    // otherwise increment upwards and reverse back when reached the end of the ID
    const $target = $(e.currentTarget);
    const $block = $target.parent(BLOCK_SELECTOR);
    const $video = $block.find('iframe');

    const ids = $block.data(DATA_ID)?.split(',') ?? [];
    const videoSrc = $video.prop('src');
    let nextIndex = 0;

    if (startsWith(videoSrc, YT_EMBED_URL)) {
        const currentId = videoSrc.substring(YT_EMBED_URL.length, YT_EMBED_URL.length + YT_ID_LEN);

        // If index is not found, nextId is set to 0
        nextIndex = ids.indexOf(currentId) + 1;

        // Wrap video id, if there is only 1 index
        if (nextIndex >= ids.length) {
            nextIndex = 0;
        }
    }

    // Set new iframe src
    $video.prop('src', YT_EMBED_URL + ids[nextIndex]);
}

/*
 * Video block
 */
export function registerVideoBlock(): void {
    const $blocks = $(BLOCK_SELECTOR);

    $blocks
        .find(BLOCK_BTN_SELECTOR)
        .on('click', swapVideo);
}